const CLOUD_PARTS = [5, 4, 3, 3, 2, 3] as const;

/** Homepage cloud language, rebuilt locally so this frontend remains independent. */
export function CloudBackground() {
  return (
    <div className="floating-clouds" aria-hidden="true">
      {CLOUD_PARTS.map((count, cloud) => (
        <span className={`float-cloud cloud-${cloud + 1}`} key={cloud}>
          {Array.from({ length: count }, (_, part) => (
            <span className={`cloud-circle cloud-circle-${part + 1}`} key={part} />
          ))}
        </span>
      ))}
      <svg className="cloud-floor" viewBox="0 0 1440 260" preserveAspectRatio="none">
        <g fill="var(--cloud)" opacity="0.55">
          <circle cx="40" cy="140" r="150" /><circle cx="260" cy="180" r="140" />
          <circle cx="490" cy="145" r="160" /><circle cx="730" cy="190" r="145" />
          <circle cx="970" cy="140" r="160" /><circle cx="1210" cy="175" r="145" />
          <circle cx="1450" cy="130" r="170" /><rect x="0" y="160" width="1440" height="100" />
        </g>
        <g fill="var(--cloud)">
          <circle cx="100" cy="205" r="100" /><circle cx="330" cy="210" r="110" />
          <circle cx="570" cy="200" r="105" /><circle cx="810" cy="220" r="110" />
          <circle cx="1050" cy="195" r="110" /><circle cx="1290" cy="210" r="115" />
          <rect x="0" y="215" width="1440" height="45" />
        </g>
      </svg>
    </div>
  );
}
